//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext,useContext} from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

 import {
  Brightness4,
  Brightness7,
} from '@mui/icons-material';

import { grey } from '@mui/material/colors';

import { ColorModeContext } from 'pages/App/components/ColorModeContext/ColorModeContext';

//#endregion

//-----------------------------------------------------------------
export function ThemeToggle() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme     = useTheme();
  const colorMode = useContext( ColorModeContext );

  const is_light = theme.palette.mode === 'light';

  const _styles = {
    container: {
      display    : 'flex'  ,
      marginLeft : 'auto'  ,
      alignItems : 'center',
      padding    : '1rem'  ,
      '&:hover': {
        background: grey[300],
     },
    },
    icon: {
      color: is_light ? theme.palette.primary.main : '',
    },
    text: {
      paddingLeft: '1rem',
    }
  }
  
  const theme_icon = is_light ? <Brightness7 sx={_styles.icon}/> : <Brightness4 sx={_styles.icon} /> ;

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function toggleTheme(event) {
    //-----------------------------------------------------------------
    colorMode.toggle();
    localStorage.setItem( 'theme', is_light ? 'dark' : 'light' );
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} onClick={toggleTheme}>
        {theme_icon}
        <Box sx={_styles.text}> Appearance </Box>
      </Box>
    );
  }

  //#endregion

  return display();
}
